@if (theme === 'tngh' || theme === 'cvte' || theme === 'wnt') {
  <lib-request-password-reset-form
    (requestReset)="onSubmit($event)"
    (navigateBack)="onClickBackButton()"
  ></lib-request-password-reset-form>
}
@else if (theme === 'mdef') {
  <mdef-request-password-reset-form
    (requestReset)="onSubmit($event)"
    (navigateBack)="onClickBackButton()"
  ></mdef-request-password-reset-form>
}
